export default "__VITE_ASSET__EwnTLG9m__"